import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Dialog } from '@mui/material';
import { AttachmentObject, openAttachment, parseAttachmentAnswer } from '@ContentManagement/attachmentAnswer';
import { Unreadable } from '@ContentManagement/Unreadable';

// require, not import: the typings of @eduact/ed-components (through its
// DataDisplay re-export) and @eduact/student-theme globally augment
// styled-components' DefaultTheme, which breaks the admin app's own theme
// typing at index.tsx. Only the runtime values are needed here.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { Attachment } = require('@eduact/ed-components');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { imageTypes, docsTypes } = require('@eduact/ed-components/DataDisplay/Attachment');
// ThemeProvider MUST be student-theme's, not styled-components': the
// Attachment tile reads student-theme's own context (useEdTheme) and throws
// "No ThemeProvider found !!!" under a bare styled-components provider.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { createTheme, ThemeProvider } = require('@eduact/student-theme');

type Props = {
	answer: string;
};

const theme = createTheme({}) as any;
const AnswerAttachments: React.VoidFunctionComponent<Props> = ({ answer }) => {
	const { attachments, unreadable } = useMemo(() => parseAttachmentAnswer(answer), [answer]);

	const [isOpen, setIsOpen] = useState(false);
	const [attachment, setAttachment] = useState<AttachmentObject | undefined>();
	const handleOpenAttachment = (attachment: AttachmentObject) => {
		if (!imageTypes.includes(attachment.type) && attachment.type !== 'pdf') {
			openAttachment(attachment.url);
			return;
		}
		setAttachment(attachment);
		setIsOpen(true);
	};
	const handleCloseAttachment = () => {
		setAttachment(undefined);
		setIsOpen(false);
	};
	return (
		<ThemeProvider theme={theme}>
			<Dialog onClose={handleCloseAttachment} maxWidth="xl" open={isOpen}>
				<>
					{attachment && (
						<div>
							{imageTypes.includes(attachment.type) && (
								<img src={attachment.url} alt="" />
							)}
							{docsTypes.includes(attachment.type) && (
								<object
									style={{ width: '90vw', height: '90vh' }}
									data={attachment.url}
									datatype="application/pdf"
								>
									<iframe
										width={'100%'}
										height={'100%'}
										src={attachment.url}
										title="Pdf"
									></iframe>
								</object>
							)}
						</div>
					)}
				</>
			</Dialog>
			<Row>
				{attachments.map((attachment) => {
					return (
						<Attachment
							key={attachment.url}
							onClick={handleOpenAttachment}
							type={attachment.type}
							url={attachment.url}
							withDelete={false}
						/>
					);
				})}
				{unreadable && <Unreadable>Some attachments could not be read.</Unreadable>}
			</Row>
		</ThemeProvider>
	);
};

export default AnswerAttachments;

const Row = styled.div`
	display: flex;
	gap: 1rem;
	flex-wrap: wrap;
`;

